export function findArrayElementById(array, id) {
    return array.find((element) => {
        return element.id === id;
    })
}